import { render, staticRenderFns } from "./HowItWorksModule.vue?vue&type=template&id=7d379727"
import script from "./HowItWorksModule.vue?vue&type=script&lang=js"
export * from "./HowItWorksModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports